"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_dnd_1 = require("react-dnd");
var UiProvider = function (_a) {
    var children = _a.children, backend = _a.backend;
    return (0, jsx_runtime_1.jsx)(react_dnd_1.DndProvider, __assign({ backend: backend }, { children: children }), void 0);
};
exports.UiProvider = UiProvider;
